var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconoImprimir(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 33.01 33.24",
    style: {
      enableBackground: "new 0 0 33.01 33.24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#7367F0;stroke-width:3;stroke-linecap:round;stroke-linejoin:round;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-printer",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3572",
    className: "st0",
    d: "M5.96,10.63V0.13h18v10.5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3573",
    className: "st0",
    d: "M5.96,24.13h-3c-1.66,0-3-1.34-3-3v-7.5c0-1.66,1.34-3,3-3h24c1.66,0,3,1.34,3,3v7.5 c0,1.66-1.34,3-3,3h-3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_3574",
    className: "st0",
    d: "M5.96,18.13h18v12h-18V18.13z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconoImprimir);
export default __webpack_public_path__ + "static/media/icono-imprimir.d78b2db658a2997102ab94555bda4a17.svg";
export { ForwardRef as ReactComponent };